<template>
  <div class="user">
    <div class="user-left">
      <template v-if="isLogin">
        <div class="name">Hi，{{ user.nickName }}</div>
        <div class="vip">{{ vips.packageName }}</div>
      </template>
      <div class="name" v-else @click="toLogin">未登录</div>
    </div>
    <el-popover
      v-if="isLogin"
      placement="bottom-end"
      width="324"
      trigger="click"
      popper-class="user-info-profile-popper"
    >
      <el-card class="reset-pass-user-card user-info-inner-card">
        <div class="member-header">
          <div class="member-info">
            <img src="../assets/avatar.png" class="member-avatar" alt="" />
            <div>
              <div class="member-name">Hi，{{ user.nickName }}</div>
              <div class="member-type-tag">{{ vips.packageName }}</div>
            </div>
          </div>
          <div>
            <div class="account-btn" @click="handleExit">退出</div>
          </div>
        </div>

        <div class="member-stats">
          <div class="stat-item">
            <span class="stat-value">{{ statistic.totalPoints }}</span>
            <span class="stat-label">积分</span>
          </div>
          <div class="stat-item">
            <span class="stat-value">{{ statistic.totalSignIn }}</span>
            <span class="stat-label">签到</span>
          </div>
          <div class="stat-item">
            <span class="stat-value">{{ statistic.totalInvite }}</span>
            <span class="stat-label">邀请</span>
          </div>
        </div>

        <div class="validity-info" :style="validityBgStyle">
          <span class="validity-tag">{{ vips.title }}</span>
          <div class="validity-days">
            <div class="remainingDays">{{ vips.remainDays >= 0 ? `剩余 ${vips.remainDays} 天` : '已过期' }}</div>
            <div class="expirationDate" v-if="vips.expireTime">有效期至 {{ vips.expireTime }}</div>
          </div>
        </div>
      </el-card>
      <img
        slot="reference"
        src="../assets/avatar.png"
        class="user-right user-avatar-trigger"
        alt=""
      />
    </el-popover>
    <img
      v-else
      src="../assets/avatar.png"
      class="user-right"
      alt=""
      @click="toLogin"
    />
  </div>
</template>

<script>
import { EventBus } from "@/eventBus";
import {
  clearUserSession,
  isSessionLoggedIn,
  getStoredUser,
  getStoredVips,
  getStoredStatistic,
} from "@/utils/userSession";

export default {
  name: "UserInfo",
  created() {
    this._onUserSessionUpdated = () => {
      this.sessionVersion += 1;
    };
    EventBus.$on("user-session-updated", this._onUserSessionUpdated);
  },
  beforeDestroy() {
    EventBus.$off("user-session-updated", this._onUserSessionUpdated);
  },
  data() {
    return {
      sessionVersion: 0,
      defaultUser: {},
      defaultVips: {},
      defaultStatistic: {},
    };
  },
  computed: {
    isLogin() {
      void this.sessionVersion;
      return isSessionLoggedIn();
    },
    user() {
      void this.sessionVersion;
      return getStoredUser() || this.defaultUser;
    },
    vips() {
      void this.sessionVersion;
      return getStoredVips() || this.defaultVips;
    },
    statistic() {
      void this.sessionVersion;
      return getStoredStatistic() || this.defaultStatistic;
    },
    validityBgStyle() {
      const bg = this.vips.background;
      const url = bg || require("../assets/vipbg.png");
      return { backgroundImage: `url(${url})` };
    },
  },
  methods: {
    handleExit() {
      this.$confirm("确定要退出登录吗？", "退出确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          clearUserSession();
          this.$message.success("退出成功！");
          EventBus.$emit("show-login-modal");
        })
        .catch(() => {
          console.log("已取消退出");
        });
    },
    toLogin() {
      this.$emit('openLogin');
    },
    toResetPass() {
      this.$emit('openResetPass');
    },
  },
};
</script>

<style scoped lang="scss">
.user {
  margin-left: 68px;
  display: flex;
  align-items: center;

  &-left {
    .name {
      font-weight: 600;
      font-size: 14px;
      color: #081f4d;
      line-height: 20px;
      cursor: pointer;
    }

    .vip {
      margin-top: 4px;
      font-size: 12px;
      color: #a5a5a5;
      line-height: 17px;
    }
  }

  &-right {
    width: 53px;
    height: 53px;
    margin-left: 35px;
    border: 1px solid #eee;
  }
}

.user-avatar-trigger {
  cursor: pointer;
}
</style>

<style lang="scss">
/* popper 挂到 body，需全局类名（与 ResetPass 用户信息卡一致） */
.user-info-profile-popper {
  padding: 8px 10px 12px;
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
  border-radius: 12px;

  .user-info-inner-card.el-card {
    border: none;
    box-shadow: none;

    .el-card__body {
      padding: 0;
    }
  }

  .reset-pass-user-card {
    width: 100%;
    max-width: 324px;
    margin: 0;
    border-radius: 10px;
    box-shadow: none;

    .member-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px;
      position: relative;

      .member-info {
        flex: 1;
        display: flex;

        .member-avatar {
          width: 46px;
          height: 46px;
          margin-right: 8px;
          background: #fff;
        }

        .member-name {
          font-size: 16px;
          color: #081f4d;
          line-height: 22px;
        }

        .member-type-tag {
          font-size: 12px;
          color: #707172;
          line-height: 17px;
          margin-top: 4px;
        }
      }

      .account-btn {
        width: 64px;
        height: 20px;
        cursor: pointer;
        font-size: 10px;
        line-height: 20px;
        text-align: center;
        background: #000000;
        color: #ffffff;
        border-radius: 10px;
        margin: 2px 0;
      }
    }

    .member-stats {
      display: flex;
      justify-content: space-around;
      padding: 15px;
    }

    .stat-item {
      text-align: center;
    }

    .stat-value {
      font-weight: 600;
      font-size: 14px;
      color: #1e2023;
      line-height: 20px;
      display: block;
    }

    .stat-label {
      font-size: 12px;
      color: #707172;
      line-height: 17px;
    }

    .validity-info {
      padding: 9px 10px;
      background-size: 100% 100%;
      width: 273px;
      height: 108px;
      max-width: 100%;
      margin: 0 auto 10px;
      box-sizing: border-box;
    }

    .validity-tag {
      margin-left: 33px;
      font-weight: 600;
      font-size: 12px;
      color: #4c535c;
      line-height: 17px;
    }

    .validity-days {
      width: 255px;
      max-width: 100%;
      height: 68px;
      background: #ffffff;
      border-radius: 10px;
      padding: 12px 18px;
      margin-top: 5px;
      box-sizing: border-box;

      .remainingDays {
        font-weight: bold;
        font-size: 16px;
        color: #000000;
        line-height: 22px;
      }

      .expirationDate {
        font-size: 12px;
        color: #999999;
        line-height: 17px;
        margin-top: 4px;
      }
    }
  }
}
</style>
